/**
 * API configuration
 */

export const API_BASE = process.env.REACT_APP_API_BASE || 'https://api.yatis.io';

